import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

const AnimatedGalleryWithGrid = () => {
  const images = [
    { src: "/images/navya/Gallery1.JPG", caption: "Room View" },
    { src: "/images/navya/Gallery2.JPG", caption: "Balcony" },
    { src: "/images/navya/Gallery3.JPG", caption: "Dining Area" },
    { src: "/images/navya/Gallery4.JPG", caption: "Common Space" },
    { src: "/images/navya/Gallery5.JPG", caption: "Reception" },
    { src: "/images/navya/Gallery6.JPG", caption: "Lounge" },
    { src: "/images/navya/Gallery7.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery8.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery9.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery10.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery11.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery12.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery13.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery14.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery15.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery16.JPG", caption: "Dining Room" },

    { src: "/images/navya/Gallery17.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery18.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery19.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery20.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery21.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery22.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery23.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery24.JPG", caption: "Dining Room" },
   { src: "/images/navya/Gallery24.JPG", caption: "Dining Room" },
    { src: "/images/navya/Gallery26.JPG", caption: "Dining Room" },
     { src: "/images/navya/Gallery27.JPG", caption: "Dining Room" },
      { src: "/images/navya/Gallery28.JPG", caption: "Dining Room" },
       { src: "/images/navya/Gallery29.JPG", caption: "Dining Room" },
        { src: "/images/navya/Gallery30.JPG", caption: "Dining Room" },
         { src: "/images/navya/Gallery31.JPG", caption: "Dining Room" },
          { src: "/images/navya/Gallery32.JPG", caption: "Dining Room" },
           { src: "/images/navya/Gallery33.JPG", caption: "Dining Room" },
            { src: "/images/navya/Gallery34.JPG", caption: "Dining Room" },

    
  ];

  const [index, setIndex] = useState(0);
  const [lightbox, setLightbox] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(1.5);
  const [frameHeight, setFrameHeight] = useState("550px");
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-50px" });

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    const ratio = naturalWidth / naturalHeight;
    setAspectRatio(ratio);
    if (ratio >= 1.2) setFrameHeight("550px");
    else if (ratio >= 0.8) setFrameHeight("650px");
    else setFrameHeight("750px");
  };

  const nextImage = () => setIndex((prev) => (prev + 1) % images.length);
  const prevImage = () => setIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
    <section ref={sectionRef} className="py-16 md:py-24 bg-white flex flex-col items-center overflow-hidden">
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className="text-center mb-10 px-4"
      >
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
          Navya Residency
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Discover elegant living spaces, modern interiors, and warm ambience.
        </p>
      </motion.div>

      {/* Main Slider */}
      <motion.div
        layout
        animate={{ height: frameHeight }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        className="relative w-full max-w-5xl overflow-hidden rounded-2xl"
      >
        <AnimatePresence mode="wait">
          <motion.img
            key={images[index].src}
            src={images[index].src}
            alt={images[index].caption}
            onLoad={handleImageLoad}
            initial={{ opacity: 0, scale: 1.02 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.98 }}
            transition={{ duration: 0.8 }}
            className="w-full h-full object-contain cursor-pointer select-none"
            onClick={() => setLightbox(images[index].src)}
          />
        </AnimatePresence>

        {/* Caption */}
        {/* <div className="absolute bottom-3 left-0 right-0 text-center">
          <span className="bg-black/40 text-white px-4 py-1 rounded-full text-sm md:text-base backdrop-blur-sm">
            {images[index].caption}
          </span>
        </div> */}

        {/* Controls */}
        <button
          onClick={prevImage}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 p-2 rounded-full transition"
        >
          <ChevronLeft className="w-6 h-6 text-white" />
        </button>
        <button
          onClick={nextImage}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 p-2 rounded-full transition"
        >
          <ChevronRight className="w-6 h-6 text-white" />
        </button>

        {/* Dots */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`w-3 h-3 rounded-full ${
                i === index ? "bg-white" : "bg-gray-400/60"
              }`}
            ></button>
          ))}
        </div>
      </motion.div>

      {/* Grid Gallery */}
      {/* <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1, delay: 0.4 }}
        className="mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 px-4 max-w-6xl"
      >
        {images.map((img, i) => (
          <motion.div
            key={i}
            whileHover={{ scale: 1.02 }}
            className="relative overflow-hidden rounded-2xl cursor-pointer group"
            onClick={() => setLightbox(img.src)}
          >
            <img
              src={img.src}
              alt={img.caption}
              className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 flex items-center justify-center transition">
              <span className="text-white text-sm md:text-base px-3 py-1 bg-black/50 rounded-full">
                {img.caption}
              </span>
            </div>
          </motion.div>
        ))}
      </motion.div> */}

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 bg-white/30 p-2 rounded-full hover:bg-white/60"
          >
            <X className="text-white w-6 h-6" />
          </button>
          <img
            src={lightbox}
            alt="Full View"
            className="max-h-[85vh] max-w-[90vw] rounded-lg object-contain"
          />
        </div>
      )}
    </section>
  );
};

export default AnimatedGalleryWithGrid;
